import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './ButtonVoirTous.scss';

const ButtonVoirTous = props => (
  <Button onClick={props.onClick ? () => props.onClick() : undefined}>
    {props.voirTous}
  </Button>
);

ButtonVoirTous.propTypes = {
  onClick: PropTypes.func,
  voirTous: PropTypes.string,
};

export default ButtonVoirTous;



// WEBPACK FOOTER //
// ./src/components/Main/home/ButtonVoirTous.js